//
//
//
//
//
//
//
//
//


export default {
  props: {
    dealers: Array
  }
}

